module.exports = __webpack_public_path__ + "img/main-banner.97f927d.png";